import { connect } from 'react-redux';
import { compose, withProps, withHandlers, branch, renderNothing } from 'recompose';

import ResetServicesOrderButton from '../components/ResetServicesOrderButton';
import confirmModal from '../../../common/confirmModal';
import withPermissions from '../../../auth/utils/withPermissions';
import withNotifications from '../../../common/withNotifications';
import {
  canUserModifyBarbers,
  canUserModifyServices,
  canUserViewServices,
} from '../../../common/helpers/users';
import { resetAllBarbersServiceOrder, resetBarberServicesOrder } from '../actions';
import { activeShop } from '../../../auth/selectors';

export default compose(
  connect(state => ({
    shop: activeShop(state),
  }), {
    resetAllBarbersServiceOrder,
    resetBarberServicesOrder,
  }),
  withPermissions,
  withNotifications,
  withProps(props => ({
    shouldShowResetOrderButton:
      canUserViewServices(props.permissions) && canUserModifyServices(props.permissions)
      && canUserModifyBarbers(props.permissions),

    resetModalTitle: props.barber ? 'Reorder Staff Member Services' : 'Reorder All Staff Member Services',
    resetModalMessage: props.barber ?
      'Are you sure you want to reorder this staff member\'s services to match this location\'s services order?'
      // eslint-disable-next-line max-len
      : 'Are you sure you want to reorder all of this location’s staff members\' services to match this location\'s services order?',
  })),
  withHandlers({
    resetServicesOrder: props => () => {
      if (props.barber) {
        return props.resetBarberServicesOrder(props.shop.id, props.barberId);
      }

      return props.resetAllBarbersServiceOrder(props.shop.id);
    },
  }),
  withHandlers({
    onButtonClick: props => async () => {
      const confirmed = await confirmModal({
        title: props.resetModalTitle,
        message: props.resetModalMessage,
        type: 'yesno',
        confirmButtonText: 'Ok',
        negativeButtonText: 'Cancel',
      });

      if (!confirmed) {
        return false;
      }

      return props.resetServicesOrder()
        .then(() => props.addNotification({
          level: 'success',
          message: 'Services successfully reordered.',
          title: 'Success',
        }));
    },
  }),
  branch(props => !props.shouldShowResetOrderButton, renderNothing),
)(ResetServicesOrderButton);
